import { useTranslation } from 'react-i18next';
import './BatchFormLogs.scss';
import {
  ActionType,
  diffObjects,
} from '../../utils/data-diff';
import logger from '../../utils/logger';
import { startCase } from 'lodash';
import React from 'react';
import batchFormMonitoredProperties from './BatchFormMonitoredProperties';

type MixDesignItem = {
  batchCode?: string;
  constituentItemCode?: string;
  quantity?: number;
  moisture?: number;
  trim?: number;
};

type MappedMixDesignItem = {
  name?: string;
  quantity?: number;
  moisture?: number;
  trim?: number;
};

function mapMixDesign(mixDesign: MixDesignItem[] = []): MappedMixDesignItem[] {
  return mixDesign.map(v => ({
    name: v.batchCode || v.constituentItemCode,
    quantity: v.quantity,
    moisture: v.moisture,
    trim: v.trim,
  }));
}

const BatchFormLogs: React.FC<any> = ({ initialValues }) => {
  const { t } = useTranslation();
  const dataFrom = JSON.parse(JSON.stringify({ ...initialValues?.originalPayload }));
  const dataTo = JSON.parse(JSON.stringify({ ...initialValues, originalPayload: null }));
  const logs = diffObjects(dataFrom, dataTo);
  const mixDesignLogs = diffObjects(mapMixDesign(dataFrom.mixDesign), mapMixDesign(dataTo.mixDesign));

  logger.log('logs', logs, mixDesignLogs);

  return (
    <div className={'log-data-content'}>
      {logs.map((item, index) => (
        item.actionType === ActionType.Changed
        && !Array.isArray(item.from)
        && !Array.isArray(item.to)
        && batchFormMonitoredProperties.includes(String(item.key)) && (
          <div key={index} className={`log-item log-type--${item.actionType}`}>
            <span className="log-item-name">{startCase(item.key)}:</span>
            <span className="log-item-change-from">{String(item.from)}</span>
            <i className={'fa fa-arrow-right-long'}/>
            <span className="log-item-change-to">{String(item.to)}</span>
          </div>
        )
      ))}

      {!!mixDesignLogs.length &&
        <h4>{t('Mix design')}:</h4>
      }

      {mixDesignLogs.map((item, index) => {
        if (item.actionType === ActionType.Changed) {
          return (
            <div key={index} className={`log-item log-type--${item.actionType}`}>
              <span className="log-item-name">{item.key.split('.').join(' ')}:</span>
              <span className="log-item-change-from">{String(item.from)}</span>
              <i className="fa fa-arrow-right-long" />
              <span className="log-item-change-to">{String(item.to)}</span>
            </div>
          );
        }

        if (item.actionType === ActionType.Added) {
          return (
            <div key={index} className={`log-item log-type--${item.actionType}`}>
              <span className="log-item-change-to">
                {t('Item added')}: {JSON.stringify(item.value)}
              </span>
            </div>
          );
        }

        return null; // render nothing for other action types
      })}

    </div>
  );
};

export default BatchFormLogs;
